<div class="d-flex flex-column align-items-center justify-content-center h-100 p-4">
    <div class="text-center mb-4">
        <div
            class="spinner-border text-primary mb-3"
            role="status"
            appVenueColour
            [primaryColour]="venue.primaryColour"
        >
            <span class="visually-hidden">Loading...</span>
        </div>
        <h4 class="mb-3">Confirming your booking...</h4>
        <p class="text-muted mb-0">
            Please wait while we process your payment details and confirm your booking.
            This may take a few moments.
            <br/>
            Please do not refresh the page or navigate away.
        </p>
    </div>
</div>
